import { Label } from "@/components/ui/label";
import type { ReactNode } from "react";

/**
 * StepLabel — a visually obvious numbered section header.
 * Use to mark the steps of a multi-step form so users can scan the page
 * and immediately see "where am I, and what do I do next?".
 */
export function StepLabel({
  n,
  htmlFor,
  children,
  hint,
  className = "",
}: {
  n: number | string;
  htmlFor?: string;
  children: ReactNode;
  hint?: ReactNode;
  className?: string;
}) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span
        aria-hidden
        className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-primary text-[11px] font-bold text-primary-foreground"
      >
        {n}
      </span>
      <Label
        htmlFor={htmlFor}
        className="text-xs font-semibold uppercase tracking-wider text-foreground"
      >
        {children}
      </Label>
      {hint && (
        <span className="ml-auto hidden text-[11px] text-muted-foreground sm:inline">
          {hint}
        </span>
      )}
    </div>
  );
}
